module.exports = {
    ACTIVE: 'active',
    PENDING: 'pending',
    RESTRICTED: 'restricted',
};
